import React from "react";
import { PoweredBy } from "react-instantsearch-dom";
import styled from "@emotion/styled";

export default styled(PoweredBy)`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  > span {
    font-size: 10px;
  }

  > a svg {
    margin-left: 4px;
    width: 50px;
  }
`;